import { ReactElement } from 'react';

import { useHiddenFormContext } from '../../contexts';

export interface HiddenFormProps {
  fields: { name: string; value: string | number }[];
  actionUrl: string;
  target: string;
}

export const HiddenForm = ({
  fields,
  actionUrl,
  target,
}: HiddenFormProps): ReactElement => {
  const { registerForm } = useHiddenFormContext();

  return (
    <form
      ref={registerForm}
      id="providerRedirectForm"
      action={actionUrl}
      method="post"
      name="provider-redirect-form-window"
      target={target}
    >
      {fields.map(({ name, value }) => (
        <input
          key={`${name}_${value}`}
          type="hidden"
          name={name}
          value={value}
        />
      ))}
    </form>
  );
};
